<template>
    <div class="site-wrapper no-header">
        <ul class="scroller">
            <li><router-link to="my-dashboard">Dashboard</router-link></li>
            <li class="is-active"><a aria-current="page">New All Assets</a></li>
        </ul>

        <div class="container">
            <div class="notification is-dark"><h3>List all assets</h3></div>

            <div class="spacer s10"></div>

            <!-- <p>keyField: {{ keyField }}</p>
            <p>tempField: {{ tempField }}</p>
            <p>findName: {{ findName }}</p> -->

            <input class="input" type="text" placeholder="Type display field name (ie vesselName).." v-model="tempField" />

            <div class="spacer s20"></div>

            <div class="buttons">
                <button class="button is-danger" @click="setKeyField()">Set key field</button>
            </div>

            <div class="spacer s20"></div>

            <div class="notification is-primary">
                <input
                    class="input"
                    v-model="findName"
                    id="filtername"
                    autocomplete="off"
                    type="text"
                    placeholder="Start typing to filter assets..."
                />
            </div>

            <hr />

            <div class="buttons" v-for="asset in filteredNames" :key="asset.id">
                <div v-if="asset.keyField != ''" class="button is-small" @click="showAsset(asset)">
                    {{ asset.vesselName }}: &nbsp;
                    <span class="red">{{ asset.keyField }}</span>
                </div>
            </div>
        </div>

        <simple-modal :title="selectedAsset.vesselName" @closed="close()" v-if="showAssetInfo">
            <pre>{{ selectedAsset.vesselOwnerName }}</pre>
        </simple-modal>
    </div>
</template>

<script>
import { db } from '../main.js';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/firestore';
// import 'firebase/compat/functions';
import NProgress from 'nprogress';
const SimpleModal = () => import('../reusables/SimpleModal.vue');

let unsubscribe;

export default {
    name: 'OneOffFunctionCall',
    components: {
        SimpleModal
    },
    props: {},
    mounted() {
        this.loadAllAssets();
    },
    unmounted() {
        if (unsubscribe) unsubscribe();
    },
    computed: {
        sortedAssets() {
            return this.allAssets.slice().sort(function(a, b) {
                // return a.keyField < b.keyField ? -1 : a.keyField > b.keyField ? 1 : 0;
                return a.vesselName < b.vesselName ? -1 : a.vesselName > b.vesselName ? 1 : 0;
            });
        },
        filteredNames() {
            let filter = new RegExp(this.findName, 'i');
            return this.keyField.trim().length == 0
                ? this.sortedAssets
                : this.sortedAssets.filter(asset => asset.keyField != '' && asset.keyField.match(filter));
        }
    },
    data() {
        return {
            allAssets: [],
            keyField: 'vesselName',
            tempField: '',
            findName: '',
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            selectedAsset: '',
            showAssetInfo: false
        };
    },
    methods: {
        close() {
            this.selectedAsset = '';
            this.showAssetInfo = false;
        },

        async loadAllAssets() {
            NProgress.start();
            await db
                .collection('vessels')
                .orderBy('vesselName', 'asc')
                .where('isExpired', '==', false)
                .get()
                .then(querySnapshot => {
                    console.log(this.keyField);
                    this.allAssets = [];
                    querySnapshot.forEach(doc => {
                        let data = doc.data();
                        data.id = doc.id;
                        data.keyField = doc.data()[this.keyField] ? doc.data()[this.keyField] : '';
                        this.allAssets.push(data);
                    });
                });
            NProgress.done();
        },

        setKeyField() {
            let t = this.tempField.trim();
            if (t == '') return;
            this.keyField = t;
            this.loadAllAssets();
        },

        showAsset(asset) {
            this.selectedAsset = asset;
            this.showAssetInfo = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.message {
    .message-body {
        background: #fff;
    }
}
textarea {
    min-height: 100px !important;
    box-shadow: none;
    padding: 0.6rem 1rem;
    &.notes {
        margin-top: 1rem;
    }
}
input[type='text'] {
    padding: 15px 20px;
    height: auto;
}
.buttons {
    margin-bottom: 3px;
    .button {
        margin-bottom: 0px;
    }
}
</style>
